import type { AfterSalesOrder } from './types';

export const mockAfterSalesOrders: AfterSalesOrder[] = [
  {
    id: '1',
    refundNo: 'RF202501150001',
    orderNo: 'ORD202501150006',
    productName: 'PC Farm',
    productPrice: 1500,
    quantity: 1,
    refundAmount: 315,
    applyTime: '2025-01-14 15:00:00',
    refundTime: '2025-01-14 15:30:00',
    operatorName: '周八',
    operatorId: 'U10006',
    status: '退款成功'
  },
  {
    id: '2',
    refundNo: 'RF202501150002',
    orderNo: 'ORD202501150007',
    productName: 'AIGC服务',
    productPrice: 3.8,
    quantity: 1,
    refundAmount: 4.75,
    applyTime: '2025-01-14 16:00:00',
    refundTime: '2025-01-14 16:25:00',
    operatorName: '吴九',
    operatorId: 'U10007',
    status: '退款成功'
  },
  {
    id: '3',
    refundNo: 'RF202501140001',
    orderNo: 'ORD202501140003',
    productName: 'GPU服务器',
    productPrice: 1200,
    quantity: 1,
    refundAmount: 3240,
    applyTime: '2025-01-13 10:00:00',
    refundTime: '',
    operatorName: '李四',
    operatorId: 'U10002',
    status: '退款失败'
  },
  {
    id: '4',
    refundNo: 'RF202501140002',
    orderNo: 'ORD202501140005',
    productName: '标准云电脑',
    productPrice: 2.5,
    quantity: 1,
    refundAmount: 3.0,
    applyTime: '2025-01-13 14:00:00',
    refundTime: '2025-01-13 14:20:00',
    operatorName: '张三',
    operatorId: 'U10001',
    status: '退款成功'
  },
  {
    id: '5',
    refundNo: 'RF202501130001',
    orderNo: 'ORD202501130002',
    productName: '数据盘',
    productPrice: 0.5,
    quantity: 100,
    refundAmount: 300,
    applyTime: '2025-01-12 09:00:00',
    refundTime: '2025-01-12 09:30:00',
    operatorName: '孙七',
    operatorId: 'U10005',
    status: '退款成功'
  },
  {
    id: '6',
    refundNo: 'RF202501130002',
    orderNo: 'ORD202501130004',
    productName: 'AI训练服务器',
    productPrice: 50,
    quantity: 1,
    refundAmount: 135,
    applyTime: '2025-01-12 11:00:00',
    refundTime: '',
    operatorName: '赵六',
    operatorId: 'U10004',
    status: '退款失败'
  }
];
